import { useState } from 'react';
import WasteLogger from './components/WasteLogger';
import WasteSummary from './components/WasteSummary';
import RecyclingCenters from './components/RecyclingCenters';

function App() {
  const [wasteData, setWasteData] = useState([]);

  const handleLogWaste = (entry) => {
    setWasteData([...wasteData, entry]);
  };

  return (
    <div>
      <h1>Waste Management App</h1>
      <WasteLogger onLogWaste={handleLogWaste} />
      <WasteSummary wasteData={wasteData} />
      <RecyclingCenters />
    </div>
  );
}

export default App;